import React, { Component } from 'react';
import { ListGroup, ListGroupItem } from 'reactstrap';

class Categories extends Component {

  render() {
    const {categories, setActiveCategory} = this.props;
    
    return (
      <ListGroup flush className="category" >
        {categories.map((category, key) => <ListGroupItem key={key} onClick={setActiveCategory.bind(null, category)}>{category.title}</ListGroupItem>)}
      </ListGroup>
    );
  }
}

export default Categories;



// WEBPACK FOOTER //
// ./src/Categories.js